/** Скрыть HTML boot-splash из public/index.html */
export function hideBootSplash() {
  if (typeof document === "undefined") return;
  const el = document.getElementById("boot-splash");
  if (!el || el.dataset.hiding === "1") return;
  el.dataset.hiding = "1";
  el.classList.add("boot-splash-hide");
  window.setTimeout(() => {
    if (el.parentNode) el.remove();
  }, 400);
}

export function isPortalAppPath(pathname = "") {
  return (
    pathname.startsWith("/app") ||
    pathname.startsWith("/manage/app") ||
    pathname.startsWith("/staff/app")
  );
}
